<template>
  <div class="my-3 d-flex flex-column align-items-center">
    <i 
      class="fas fa-box-open" 
      aria-hidden="true"
      :style="{ fontSize: sizeIcon }"
    />
    <h2
      :style="{ fontSize: sizeText }"
    >{{ message }}</h2>

  </div>
</template>

<script>
export default {
  name: 'EmptyResults',

  props: {
    message: {
      type: String,
      default: 'No se encontraron resultados'
    },

    size: {
      type: String,
      default: 'md'
    }
  },

  computed: {
    sizeIcon() {

      return this.size === 'sm' 
        ? '50px' 
        : this.size === 'md'
          ? '100px'
          : '150px'
    },


    sizeText() {
      return this.size === 'sm' 
        ? '15px' 
        : this.size === 'md'
          ? '25px'
          : '35px'
    }
  }
}
</script>